import * as React from 'react'

import {
  BasketContext,
  EnterpriseContext,
  i18n,
} from '@thg-commerce/enterprise-core'
import { ModalRenderer } from '@thg-commerce/enterprise-modal'

import { ClickAndCollectModal } from '../ClickAndCollectModal/ClickAndCollectModal'

export const ClickAndCollectModalPresenter = () => {
  const { presentClickAndCollectModal } = React.useContext(BasketContext)
  const { headerHeight } = React.useContext(EnterpriseContext)
  const [visible, setVisible] = React.useState(false)

  const modalCloseI18nText = {
    closeAriaLabel: i18n('general.modal.close.button.arialabel'),
    closeLabel: i18n('general.modal.close.button.label'),
  }

  if (!presentClickAndCollectModal) {
    return null
  }

  presentClickAndCollectModal.current = () => {
    setVisible(true)
  }

  if (!visible) {
    return null
  }

  return (
    <ModalRenderer
      data-testid="click-and-collect-modal"
      onClose={() => setVisible(false)}
      gridColSpan={[12, 6, 8, 8]}
      headerOffset={headerHeight}
      closeI18nText={modalCloseI18nText}
      contentPadding="0 0 16px 0"
      showHeader={true}
      stickyHeader={true}
      renderContent={() => <ClickAndCollectModal />}
    />
  )
}
